(ns common.queries
  (:require ["@tanstack/react-query" :as query]
            [cljs-bean.core :refer [->clj ->js bean]]
            [common.queries.http :as qhttp]
            [re-frame.core :as rf]
            [uix.core :refer [$ defui]]))

(def query-client (query/QueryClient.
                   #js {:defaultOptions #js {:queries #js {:select ->clj}}}))

(rf/reg-fx :qhttp/set-auth-token!
  (fn [token]
    (qhttp/set-auth-token! (some->> token (str "lemonpi ")))))

(defui query-provider [{:keys [children]}]
  ($ query/QueryClientProvider
     {:client query-client}
     children))

(defn use-query
  "Wrap useQuery with shallow Cljs transformation
  for the return value.

  Use query :select option to transform the JS data
  into Cljs."
  [query]
  (bean (query/useQuery query)))

(defn use-queries
  "Wrap useQueries with shallow Cljs transformation
  for the return value.

  Use query :select option to transform the JS data
  into Cljs."
  [query]
  (bean (query/useQueries query)))

(defn use-suspense-query
  "Wrap useSuspenseQuery with shallow Cljs transformation
  for the return value.

  Use query :select option to transform the JS data
  into Cljs."
  [query]
  (bean (query/useSuspenseQuery query)))

(defn use-suspense-queries
  "Wrap useSuspenseQueries with shallow Cljs transformation
  for the return value.

  Use query :select option to transform the JS data
  into Cljs."
  [query]
  (bean (query/useSuspenseQueries query)))

(defn use-infinite-query
  "Wrap useQuery with shallow Cljs transformation
  for the return value.

  Use query :select option to transform the JS data
  into Cljs."
  [query]
  (bean (query/useInfiniteQuery query)))

(defn use-mutation
  "Wrap useMutation with shallow Cljs transformation
  for the return value."
  [mutation]
  (bean (query/useMutation mutation)))

(defn invalidate-queries
  "Wrap invalidateQueries with deep to JS transformation.

  Note that the parameter should be a map/object with :queryKey
  parameter, not the queryKey directly."
  [partial-query]
  {:pre [(:queryKey partial-query)]}
  (.invalidateQueries query-client (->js partial-query)))

(defn set-query-data
  [query new-data-or-fn]
  (.setQueryData query-client query new-data-or-fn))

(defn make-refetch-interval-fn [{:keys [interval-fn]}]
  (fn [^js query]
    (let [invalidated? (.-isInvalidated (.-state query))
          update-count (.-dataUpdateCount (.-state query))

          ;; Keep track of when the query was last invalidated,
          ;; so we can count the max refetches from the invalidation.
          previous-start-update-count (if invalidated?
                                        update-count
                                        (or (.-previousUpdateCount query) 0))
          _ (set! (.-previousUpdateCount query) previous-start-update-count)
          fetch-count (- update-count previous-start-update-count)

          fetch-interval (interval-fn query fetch-count)]
      fetch-interval)))

(defn sigmoid [x] (/ 1 (+ 1 (Math/exp (* -1 x)))))

(def max-fetches 6)
(def max-fetch-interval (* 6 1000))

(defn prevent-client-error-retries [_failure-count {:keys [status]}]
  (not (<= 400 status 499)))
